import { getPreloaderFnContext, query } from '@confluence/query-preloader-tools';

import { GetLicensedProductsQuery } from './graphql/GetLicensedProductsQuery.graphql';
import type { GetLicensedProductsQuery as GetLicensedProductsQueryType } from './graphql/__types__/GetLicensedProductsQuery';

export async function preloadGlobalAppShortcutsLicensedProducts() {
	const { cloudId } = await getPreloaderFnContext();

	return query<GetLicensedProductsQueryType, { cloudId: string }>({
		query: GetLicensedProductsQuery,
		fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'network-only',
		variables: { cloudId },
	});
}
